import { Decimal, Ulid } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import {
    CreateProjectPurchaseParams,
    UpdateProjectPurchaseParams,
} from "./interfaces";

export const makeAccounting = ({ connection }: ApiSliceParams) => {
    const create = async ({
        id,
        company,
        purchasePrice,
        comment,
        vatClass,
        markup,
        purchaseCode,
        purchaseOrder,
        project,
    }: CreateProjectPurchaseParams) => {
        const res = await connection.value.approve.invoice.accounting.create({
            invoice: id,
            company,
            purchase_price: Decimal.from(purchasePrice),
            comment,
            vat_class: vatClass,
            kind: {
                $case: "purchase",
                purchase: {
                    purchase_order: purchaseOrder,
                    project,
                    purchase_code: purchaseCode,
                    mark_up: markup ? Decimal.from(markup) : undefined,
                },
            },
        });

        return res.toString();
    };

    const update = async ({
        id,
        company,
        purchasePrice,
        comment,
        vatClass,
        markup,
        purchaseCode,
        purchaseOrder,
        project,
    }: UpdateProjectPurchaseParams) => {
        return connection.value.approve.invoice.accounting.update({
            id,
            company,
            purchase_price: purchasePrice
                ? new Decimal(purchasePrice)
                : undefined,
            comment,
            vat_class: vatClass,
            kind: {
                $case: "purchase",
                purchase: {
                    purchase_order: purchaseOrder,
                    project,
                    purchase_code: purchaseCode,
                    mark_up: markup ? Decimal.from(markup) : undefined,
                },
            },
        });
    };

    const remove = async (id: Readonly<Ulid>, company: string) => {
        return connection.value.approve.invoice.accounting.delete({
            id,
            company,
        });
    };

    return {
        create,
        update,
        remove,
    };
};
